export const PHONE_VERIFY_REQUEST = 'PHONE_VERIFY_REQUEST';
export const PHONE_VERIFY_SUCCESS = 'USER_REGISTER_SUCCESS';
export const PHONE_VERIFY_FAIL = 'PHONE_VERIFY_FAIL';
export const PHONE_VERIFY_CLEAR = 'PHONE_VERIFY_CLEAR';